function removeParenthesisAndContent(str) {
    return str.replace(/ *\([^)]*\) */g, "");
}

export default removeParenthesisAndContent;
